export function setTrades(state, items) {
   state.trades = items;
}

export function setLoaded(state, loaded) {
   state.loaded = loaded;
}

export function reset(state) {
   state.trades = [];
   state.loaded = false;
}
